var map = {
	"./de/learn.json": [
		5840,
		840
	],
	"./en/learn.json": [
		7700,
		700
	],
	"./fr/learn.json": [
		6179,
		179
	],
	"./it/learn.json": [
		9946,
		946
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6314;
module.exports = webpackAsyncContext;